
define('text!modules/media/pmp-d/templates/pmp-d.html',[],function () { return 'PMP-D section\n';});

